import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import moment from 'moment';
import {
    Box,
    Typography
} from '@material-ui/core';

import './Navbar.scss'

import arrowRight from '../../images/arrow.svg'

export default withTranslation()(function Navbar({t, step, noStep}) {
    let locale = 'en';
    
    switch (i18n.language){
        case "en":
            locale = 'en';
            break;
        case "tc":
            locale = 'zh-hk';
            break;
        case "sc":
            locale = 'zh-cn';
            break;
    }
    
    useEffect(() =>
        {moment.locale(locale)}
        , [i18n.language]
    )
    
    return (
        <Box className="navBar">
            {
                !noStep &&
                <Box className="stepWrapper">
                    <Box className={step === 'step1' ? 'stepItm active' : 'stepItm'}>
                        <Typography variant="h6" component="h4">
                            {t('common.step1')}
                        </Typography>
                        <Typography variant="subtitle1" component="h5">
                            {t('common.step1Title')}
                        </Typography>
                    </Box>
                    <Box className={step === 'step2' ? 'stepItm active' : 'stepItm'}>
                        <Typography variant="h6" component="h4">
                            {t('common.step2')}
                        </Typography>
                        <Typography variant="subtitle1" component="h5">
                            {t('common.step2Title')}
                        </Typography>
                    </Box>
                    <Box className={step === 'step3' ? 'stepItm active' : 'stepItm'}>
                        <Typography variant="h6" component="h4">
                            {t('common.step3')}
                        </Typography>
                        <Typography variant="subtitle1" component="h5">
                            {t('common.step3Title')}
                        </Typography>
                    </Box>
                    <Box className={step === 'step4' ? 'stepItm active' : 'stepItm'}>
                        <Typography variant="h6" component="h4">
                            {t('common.step4')}
                        </Typography>
                        <Typography variant="subtitle1" component="h5">
                            {t('common.step4Title')}
                        </Typography>
                    </Box>
                </Box>
            }
            <Box className="navInfo">
                <Box className="navInfoItm">
                    <Typography variant="h6" component="h4">
                        {t('common.templeDownload')}
                        <br />
                        <a href= {window.location.origin + "/EPASService/file/download/location"}>
                            {t('common.locationFile')}
                        </a>
                        <br />
                        <a href= {window.location.origin + "/EPASService/file/download/vehicle"}>
                            {t('common.vehicleFile')}
                        </a>
                    </Typography>
                    <img src={arrowRight} alt="" />
                </Box>
                
                <Box className="navInfoItm">
                    <Typography variant="h6" component="h4">
                        <a href= {`${window.location.origin}${process.env.REACT_APP_SUB_ROUTE}/Faq`} target="_blank" rel="noopener noreferrer">
                            {t('common.faq')}
                        </a>
                    </Typography>
                    <img src={arrowRight} alt="" />
                </Box>
                <Box className="navInfoItm">
                    <Box>
                        <Typography variant="h6" component="h4">
                            {t('common.helpDesk')}
                        </Typography>
                        <Typography variant="body1">
                            {t('common.contact', {tel: "2804 2600", email: "tdenq@td.gov.hk"})}
                        </Typography>
                    </Box>

                    <img src={arrowRight} alt="" />
                </Box>
            </Box>
        </Box>
    )
})
